import { FOLLOWUP_TAKE_IN_PATH_PREFIX } from "@/features/case_follow_up/shared/constants/followupRoutes";

export function routeAllowed(pathname: string, allowedRoutes: string[]): boolean {
    // Routes that are always public or don't require menu permission
    const PUBLIC_ROUTES = [
        '/login',
        '/signup',
        '/unauthorized',
        '/about',
        '/', // Root might redirect, but safe to allow initial load
        '/reset-password',
        '/forgot-password'
    ];

    // Derived Access Mapping: If key route is Allowed, then Value pattern is also Allowed
    //
    // The unified review lives under /case-review/, so it inherits the same case-access permission
    // as the original review. /catalog-case-review/ remains only for redirecting old bookmarks.
    const DERIVED_ROUTES: Record<string, (path: string) => boolean> = {
        "/list": (path) => path.startsWith("/case/") || path.startsWith("/case-review/")
            || path.startsWith("/catalog-case-review/"),
        "/literature-inbox": (path) => path.startsWith("/literature/"),
        "/signal-review": (path) => path.startsWith("/signal/"),
        "/signal-forum": (path) => path.startsWith("/signal-forum/"),
        // The Source Doc file name opens the upload detail page (KRKA-22, #311).
        "/assignment-center": (path) => path.startsWith("/file-upload/"),
        "/assignment-center/work-queue": (path) =>
            path.startsWith("/duplicate-review/") || path.startsWith("/case-review/")
            || path.startsWith(FOLLOWUP_TAKE_IN_PATH_PREFIX)
            || path.startsWith("/catalog-case-review/") || path.startsWith("/file-upload/"),
        "/signals/queue": (path) => path.startsWith("/signals/queue/"),
        "/file-upload": (path) => path.startsWith("/file-upload/"),
        "/intake-triage": (path) => path.startsWith("/intake-triage/"),
        "/configuration/access-management/users": (path) =>
            path.startsWith("/configuration/access-management/permissions-setup/"),
    };

    return PUBLIC_ROUTES.some(route => pathname === route || pathname.startsWith(route + '/'))
        || allowedRoutes.includes(pathname)
        || Object.entries(DERIVED_ROUTES).some(([route, matches]) => allowedRoutes.includes(route) && matches(pathname));
}
